const attributes = {
  toast: {
    error: {
      badResponse: '[מאפיינים] שגיאת עדכון',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {
        default: '[מאפיינים] עודכן בהצלחה',
      },
      delete: {
        body: 'מאפיינים נמחקו בהצלחה',
      },
    },
  },
  table: {
    headerButtons: {
      create: 'הוסף',
      delete: {
        label: 'מחק',
        deleteModal: {
          header: 'מחק מאפיינים',
          body: 'אתה עומד למחוק {{attributes}} מאפיינים',
        },
      },
      clear: {
        label: 'נקה',
        clearModal: {
          header: 'נקה מאפיינים',
          body: 'אתה עומד לנקות {{attributes}} מאפיינים',
        },
      },
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    placeholder: {
      select: 'בחר',
    },
    headers: {
      name: 'שם',
      labels: 'תוויות',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  form: {
    header: {
      createAttribute: {
        title: 'הוסף',
      },

      updateAttribute: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
      resetButton: 'איפוס הגדרות מתקדמות',
    },

    information: {
      details: {
        header: 'מידע כללי',
        fields: {
          name: 'שם',
          description: 'תיאור',
        },
      },

      aliases: {
        header: 'מיפוי שם מאפיין',
        fields: {
          drivers: 'נהגים',
          vehicles: 'רכבים',
          bookings: 'הזמנות',
        },
      },

      advanced: {
        header: 'הגדרות מתקדמות',
        fields: {
          sharedRideRatio: 'יחס זמן משותף מקסימלי',
          maxSharedDistanceRatio: {
            label: 'יחס מרחק משותף מקסימלי',
            description: 'מגדיר בכמה נסיעה משותפת יכולה להיות ארוכה יותר לעומת מרחק הנסיעה היחידנית. דוגמה: אם מרחק נסיעה יחיד הוא 1 מייל והיחס הוא 1.2x, הנסיעה המשותפת לא יכולה לעלות על 1.2 מייל',
          },
          maxSinglePassengerTime: 'זמן נסיעה מקסימלי לנוסע יחיד',
          maxPassengers: 'מקסימום נוסעים',
          maxTripStops: 'מקסימום עצירות',
          tripBoardingTime: 'זמן עלייה',
          tripBoardingTimeForSubsequentPassengers: 'זמן עלייה משני',
          tripDropOffTime: 'זמן הורדה',
          tripDropOffTimeForSubsequentPassengers: 'זמן הורדה משני',
          attributeReassignment: 'אפשר הפקה מחודשת בהתאם למאפיינים',
          attributeReassignmentDescription:
            'כאשר הגדרה זו מופעלת היא מפעילה הפקה מחודשת אוטומטית של נסיעות בתגובה לעדכונים במאפייני הזמנה ספציפיים. ללא הפעלת הגדרה זו שינויים במאפיינים לא יגרמו להפקה מחודשת.',
          matchScore: 'הפעל התאמת מאפיינים בין נהג/רכב להזמנה',
          matchScoreDescription:
            'הפעלת הגדרה זו מאפשרת למערכת להתחשב בהתאמת מאפיינים בעת ציוות נהגים/רכבים להזמנות. ללא הפעלת הגדרה זו המערכת תתעלם ממאפיין זה בעת ציוות נהגים/רכבים להזמנות.',
          maxBoardingDelay: 'עיכוב מקסימלי בעלייה',
          maxBoardingEarly: 'עלייה מוקדמת מקסימלית',
          maxDropOffEarly: {
            label: 'הקדמה מקסימלית בהורדה',
            description: 'מספר מקסימלי של דקות שבהן הנהג יכול להקדים ביחס לזמן ההורדה שהוגדר בהזמנה.',
          },
          maxDropOffDelay: {
            label: 'עיכוב מקסימלי בהורדה',
            description: 'מספר מקסימלי של דקות שבהן הנהג יכול לאחר לזמן ההורדה שהוגדר בהזמנה.',
          },
          minScore: 'ציון מינימלי',
          waitAndReturn: 'המתן וחזור',
          waitAndReturnDescription:
            'משך הזמן בדקות שבו נהג ימתין בין הנסיעה הלוך לחזור בנסיעת המתן וחזור.',
          off: 'כבוי',
          maxPassengerAtOnce: 'מקסימום נוסעים בו-זמנית',
          maxPickupStops: 'מקסימום עצירות איסוף',
          maxDropoffStops: 'מקסימום עצירות הורדה',
          groupWaitAndReturn: 'המתנה וחזרה',
          groupWaitAndReturnOptions: {
            off: 'כבוי',
            individualPair: 'אדם בודד',
            multiplePairs: 'קבוצה של אנשים',
          },
          onlyPrivate: 'פרטי בלבד',
          maxSimultaneousBookings: 'מקסימום הזמנות בו-זמנית',
          sharedWith: 'שותף עם',
          willCallTimeOffset: 'סטיית זמן של Will Call (בדקות)',
          leg: {
            label:'הפעל כמקטע',
            description: 'מקטע זה כבר משויך למאפיין אחר'
          }
        },
      },
    },
    valdations: {
      name: {
        required: 'שם נדרש',
        name: 'שם לא חוקי',
      },
      unit: {
        required: 'יחידה נדרשת',
        name: 'אתר לא חוקי',
      },
      parameters: {
        required: 'נדרשים פרמטרים',
        name: 'בדוק בקפידה את הערכים שאתה מעביר',
      },
    },
    create: {
      toastError: {
        message: 'לא ניתן ליצור',
      },
      toastSuccess: {
        message: 'נוצר בהצלחה',
      },
    },

    update: {
      formTabs: {
        generalInfo: 'כללי',
        advanced: 'הגדרות מתקדמות',
        history: 'היסטוריה',
      },
      toastError: {
        message: 'לא ניתן לעדכן',
      },
      toastSuccess: {
        message: 'עודכן בהצלחה',
      },
    },
  },
};

export default attributes;
